export const spribeData = {
  spribe1: {
    redirectUrl: "/casino/spribe/mines",
    imgUrl: "./images/spribe/Mines.webp",
    name: "Mines",
  },
  spribe2: {
    redirectUrl: "/casino/spribe/goal",
    imgUrl: "./images/spribe/Goal.webp",
    name: "Goal",
  },
  spribe3: {
    redirectUrl: "/casino/spribe/dice",
    imgUrl: "./images/spribe/Dice.webp",
    name: "Dice",
  },
  spribe4: {
    redirectUrl: "/casino/spribe/aviator",
    imgUrl: "./images/spribe/Aviator.webp",
    name: "Aviator",
  },
  spribe5: {
    redirectUrl: "/casino/spribe/plinko",
    imgUrl: "./images/spribe/Plinko.webp",
    name: "Plinko",
  },
  spribe6: {
    redirectUrl: "/casino/spribe/miniroulette",
    imgUrl: "./images/spribe/MiniROulette.webp",
    name: "Mini Roulette",
  },
  spribe7: {
    redirectUrl: "/casino/spribe/hilo",
    imgUrl: "./images/spribe/Hilo.webp",
    name: " Hilo",
  },
};
